import { graphql } from '../gql';
export const SELLER_FRAGMENT = graphql(`
  fragment SellerFields on Seller {
    id
    idAlias
    companyName
    displayName
    handle
    storefrontUrl
    firstName
    lastName
    phone
    email
    status
    address {
      countryCode
    }
    settings {
      ...SellerSettingsFragment
    }
    profileImage {
      url
    }
    terms {
      version
      termsAndConditions {
        version
        createdAt
      }
      status
    }
    payoutAccount {
      __typename
      ... on PaypalPayoutAccount {
        userId
        email
      }
      ... on StripePayoutAccount {
        accountId
        active
        requirementsDue
        outstandingRequirements
        bankAccount {
          name
          last4Digits
          currency
          countryCode
        }
      }
    }
  }
`);

export const USER_FRAGMENT = graphql(`
  fragment UserFields on User {
    username
    firstName
    lastName
    phone
    email
    shopManaged
    companyName
    isRegistered
    status
    seller {
      ...SellerFields
    }
    settings {
      ...SettingsFragment
    }
  }
`);

export const LOGOUT_MUTATION = graphql(`
  mutation logout {
    logout
  }
`);

export const REGISTER_MUTATION = graphql(`
  mutation register($value: RegisterUserInput!) {
    register(value: $value) {
      user {
        ...UserFields
      }
      tokens {
        accessToken
        idToken
        refreshToken
      }
    }
  }
`);

export const VERIFY_CODE_MUTATION = graphql(`
  mutation verifyCode($value: VerifyCodeInput!) {
    verifyCode(value: $value) {
      ...UserFields
    }
  }
`);

export const RESEND_CODE_MUTATION = graphql(`
  mutation resendCode($username: String!) {
    resendCode(username: $username)
  }
`);

export const FORGOT_PASSWORD_MUTATION = graphql(`
  mutation forgotPassword($username: String!) {
    forgotPassword(username: $username)
  }
`);

export const FORGOT_PASSWORD_RESET_MUTATION = graphql(`
  mutation forgotPasswordReset($value: PasswordResetInput!) {
    forgotPasswordReset(value: $value)
  }
`);

export const VALIDATE_INVITATION_QUERY = graphql(`
  query validateInvitation($invitationCode: String!) {
    validateInvitationStatus(invitationCode: $invitationCode) {
      status
    }
  }
`);

export const ACCEPT_TERMS_MUTATION = graphql(`
  mutation acceptTerms($version: String!) {
    acceptTerms(version: $version) {
      ...SellerFields
    }
  }
`);

export const COMPLETE_REGISTRATION_MUTATION = graphql(`
  mutation completeRegistration(
    $completeRegistration: CompleteRegistrationInput!
  ) {
    completeRegistration(completeRegistration: $completeRegistration) {
      ...UserFields
    }
  }
`);

export const ACCEPT_INVITATION_MUTATION = graphql(`
  mutation acceptInvitation($invitationCode: String!, $password: String!) {
    acceptInvitation(invitationCode: $invitationCode, password: $password) {
      user {
        ...UserFields
      }
      tokens {
        accessToken
        idToken
        refreshToken
      }
    }
  }
`);

export const LOGIN_MUTATION = graphql(`
  mutation login($value: UserLoginInput!) {
    login(value: $value) {
      user {
        ...UserFields
      }
      tokens {
        accessToken
        idToken
        refreshToken
      }
    }
  }
`);

export const LOGIN_SESSION_MUTATION = graphql(`
  mutation loginSession($value: UserLoginTokensInput!) {
    loginSession(value: $value) {
      user {
        ...UserFields
      }
      tokens {
        accessToken
        idToken
        refreshToken
      }
    }
  }
`);

export const REFRESH_ACCESS_TOKEN_MUTATION = graphql(`
  mutation refreshAccessToken($username: String!, $refreshToken: JWT!) {
    refreshAccessToken(username: $username, refreshToken: $refreshToken) {
      user {
        ...UserFields
      }
      tokens {
        accessToken
        idToken
        refreshToken
      }
    }
  }
`);

export const ME_QUERY = graphql(`
  query me {
    me {
      ...UserFields
    }
  }
`);

export const SELLER_QUERY = graphql(`
  query seller {
    seller {
      ...SellerFields
    }
  }
`);

export const UPDATE_SELLER_MUTATION = graphql(`
  mutation updateSeller($seller: SellerInput!) {
    updateSeller(seller: $seller) {
      ...SellerFields
    }
  }
`);
